import { render, staticRenderFns } from "./user_header.vue?vue&type=template&id=4c7ffac0&scoped=true"
import script from "./user_header.vue?vue&type=script&lang=js"
export * from "./user_header.vue?vue&type=script&lang=js"
import style0 from "./user_header.vue?vue&type=style&index=0&id=4c7ffac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7ffac0",
  null
  
)

export default component.exports